// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","logo":"Footer_logo__+JiYo","copy":"Footer_copy__V37yO"};